var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuySmsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_5415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.15594V2.41682C22.5 1.23011 21.5345 0.264648 20.3478 0.264648H2.65218C1.46546 0.264648 0.5 1.23011 0.5 2.41682V8.15594C0.5 9.34266 1.46546 10.3081 2.65218 10.3081H8.44866L11.9131 20.7015C12.1303 21.353 13.0567 21.3544 13.2743 20.7015L14.4291 17.2373L19.026 21.8343C19.5854 22.3936 20.4956 22.3936 21.0551 21.8343L22.0697 20.8197C22.629 20.2603 22.629 19.3501 22.0696 18.7907L17.4727 14.1937L20.9369 13.039C21.5887 12.8216 21.5894 11.8953 20.9369 11.6778L16.8281 10.3082H20.3478C21.5345 10.3081 22.5 9.34266 22.5 8.15594ZM18.4414 12.3583L15.9177 13.1995C15.412 13.3681 15.261 14.011 15.6373 14.3874L21.055 19.8052L20.0404 20.8197L14.6228 15.4019C14.2456 15.0247 13.6034 15.1772 13.4349 15.6824L12.5937 18.206L9.66979 9.43444C9.84605 9.49322 17.7866 12.1401 18.4414 12.3583ZM12.5237 8.87339V8.87335L8.76242 7.61961C8.20314 7.433 7.66822 7.96684 7.85496 8.52707L7.97042 8.87344H2.65218C2.25661 8.87344 1.93477 8.5516 1.93477 8.15603V2.41687C1.93477 2.0213 2.25661 1.69946 2.65218 1.69946H20.3478C20.7434 1.69946 21.0652 2.0213 21.0652 2.41687V8.15603C21.0652 8.5516 20.7434 8.87344 20.3478 8.87344L12.5237 8.87339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_5415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5 0.259277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuySmsIcon);
export default __webpack_public_path__ + "static/media/BuySMSIcon.8f55d2d0fdab040ada7ad47e7116ac9b.svg";
export { ForwardRef as ReactComponent };